import React from "react";
import { Text } from "@jsq/ds/core";
import { type ExtensionFieldValueObjectType } from "~/graphql/supergraphTypes";

interface TextFieldRendererProps {
  value: ExtensionFieldValueObjectType;
}

export const TextFieldRenderer: React.FC<TextFieldRendererProps> = ({ value }) => {
  const textValue = value.stringValue;

  if (!textValue) {
    return <Text variant="secondary-sm">—</Text>;
  }

  return (
    <Text variant="regular-md" title={textValue}>
      {textValue}
    </Text>
  );
};
